<template>
  <v-container fluid class="pt-0">
    <base-material-card color="primary" icon="mdi-clipboard-outline" inline class="ml-0 px-5 py-4" :title="titulo">
      <v-btn
        v-if="accessReleased('RELATORIOS_ADICIONAR')"
        id="btn-novo-relatorio"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="$emit('click-novo-relatorio:triggered')"
      >
        <v-icon left size="30px">mdi-plus-circle</v-icon>
        Novo Relatório
      </v-btn>
      <v-text-field
        id="relatorios-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />
      <general-progress-bars class="mt-11" :items="downloadProgressData" prefixText="Baixando Relatório" />
      <v-divider class="mt-10" />
      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        :mobile-breakpoint="800"
        :loading="loading"
        :hide-default-header="loading"
        :hide-default-footer="loading"
        no-data-text="Nenhum relatório disponível"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:[`item.nome`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="text-truncate-column" v-bind="attrs" v-on="on">
                {{ item.nome }}
              </div>
            </template>
            <span>{{ item.nome }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.ultima_execucao`]="{ item }">
          {{ item.ultima_execucao | parseToDateTimeBR }}
        </template>
        <template v-slot:[`item.numero_registros`]="{ item }">
          {{ item.numero_registros | parseNumberToIntegerBR }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="action-download-rel"
            :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
            :disabled="item.status != 'SUCESSO'"
            color="gray"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :loading="downloadProgressData[item.id] !== undefined ? true : false"
            @click="downloadSpreadSheet(item.id, item.nome)"
          >
            <v-icon small>mdi-download</v-icon>
          </v-btn>
          <v-btn
            v-if="accessReleased('RELATORIOS_EDITAR')"
            id="action-edit-rel"
            :class="item.tipo == 'RELATORIO-FROM-MODELO' || !canEditItem(item) ? 'cursor-block' : ''"
            :disabled="item.tipo == 'RELATORIO-FROM-MODELO' || !canEditItem(item)"
            :title="item.tipo == 'RELATORIO-FROM-MODELO' ? 'relatórios criados a partir de modelos não podem ser editados' : ''"
            color="gray"
            min-width="0"
            class="ml-n1 px-1"
            fab
            icon
            x-small
            @click="editarRelatorio(item.id, item.tipo)"
          >
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            id="action-favoritar-rel"
            class="ml-n1 px-1"
            :color="item.favorito ? 'primary' : 'gray'"
            min-width="0"
            fab
            icon
            x-small
            @click="favoritar(item)"
          >
            <v-icon small>mdi-star</v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more-rel"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>mdi mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-if="item.status == 'SUCESSO' && accessReleased('RELATORIOS_VISUALIZAR')"
                @click="$router.push(`visualizar/${item.id}`)"
              >
                <v-list-item-title>
                  <v-icon small>mdi-eye-outline</v-icon>
                  Visualizar
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="item.status === 'FALHA' && item.mensagem_erro && userIsAdmin"
                @click="((dialogMensagemErroData = item.mensagem_erro), (dialogMensagemErro = true))"
              >
                <v-list-item-title>
                  <v-icon small>mdi-file-alert-outline</v-icon>
                  Visualizar Erro
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="canRunItem(item)" @click="executarItem(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-play</v-icon>
                  Executar
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="item.tipo != 'RELATORIO-FROM-MODELO'" @click="duplicarItem(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-content-copy</v-icon>
                  Duplicar
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="canDeleteItem(item)" @click="openDialogDelete(item.id, item.nome)">
                <v-list-item-title>
                  <v-icon small>mdi-trash-can-outline</v-icon>
                  Deletar
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="item.tipo === 'RELATORIO-FROM-MODELO'"
                @click="openDialogDetalhes(normalizeValueToDetalhesDialog(item))"
              >
                <v-list-item-title>
                  <v-icon small>mdi-file-find-outline</v-icon>
                  Detalhes
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="item.tipo === 'RELATORIO-FROM-MODELO' && userIsAdmin"
                @click="((dialogSqlData = item.codigo_sql), (dialogSql = true))"
              >
                <v-list-item-title>
                  <v-icon small>mdi-key</v-icon>
                  Visualizar SQL
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="item.status == 'SUCESSO'" @click="downloadSpreadSheet(item.id, item.nome, 'csv')">
                <v-list-item-title>
                  <v-icon small>mdi-download</v-icon>
                  Baixar CSV
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="
                  ((dialogCreationLog = true),
                  (dialogCreationLogData = {
                    username: item.usuario,
                    created: item.created
                  }))
                "
              >
                <v-list-item-title>
                  <v-icon small>mdi-table-search</v-icon>
                  Log
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`footer.page-text`]>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" v-bind="attrs" v-on="on" @click="$emit('rechargeTable')">mdi-refresh</v-icon>
            </template>
            <span>Clique aqui para recarregar os relatórios</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
    <dialog-creation-log :dialog.sync="dialogCreationLog" :item="dialogCreationLogData" />
    <dialog-delete :dialog.sync="dialogDelete" @submitTriggered="deletarItem(dialogDeleteData.id)">
      <template slot="title">Deletar Relatório #{{ dialogDeleteData.id }}</template>
      <template slot="body">
        Tem certeza que deseja deletar o relatório
        <strong>{{ dialogDeleteData.titulo }}</strong>
        ?
      </template>
    </dialog-delete>
    <dialog-detalhes title="Detalhes do Relatório Modelo" :dialog.sync="dialogDetalhes">
      <template slot="body">
        <v-data-table
          :headers="dialogDetalhesHeader"
          :items="dialogDetalhesData"
          hide-default-footer
          class="elevation-1 style-table-dialog-detalhes"
          disable-pagination
          :mobile-breakpoint="0"
        >
          <template v-slot:item="row">
            <tr>
              <td class="button" width="170px">
                {{ row.item.nome }}
              </td>
              <td class="button" width="140px">
                {{ translateCriterio(row.item.criterio) }}
              </td>
              <td v-if="!row.item.lista" class="button">
                {{ row.item.valor }}
              </td>
              <td v-else class="button" style="padding-left: 0px !important">
                <v-textarea
                  class="label-rdt-ta mb-n5 ml-4 mt-0 pt-10"
                  :value="row.item.valor.join('\n')"
                  rows="5"
                  no-resize
                  readonly
                  filled
                />
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </dialog-detalhes>
    <dialog-sql title="Visualizador de SQL" :dialog.sync="dialogSql" :scrollable="false">
      <template slot="body">
        <v-textarea class="label-rdt-ta mb-n5 mt-0 mx-4" :value="dialogSqlData" rows="10" no-resize readonly filled />
      </template>
    </dialog-sql>
    <dialog-mensagem-erro title="Mensagem de Erro" :dialog.sync="dialogMensagemErro" :scrollable="false">
      <template slot="body">
        <v-textarea class="label-rdt-ta mb-n5 mt-0 mx-4" :value="dialogMensagemErroData" rows="10" no-resize readonly filled />
      </template>
    </dialog-mensagem-erro>
  </v-container>
</template>

<script>
  import RelatoriosService from '@/services/RelatoriosService';
  import powerupsActionsMixins from '@/mixins/powerupsActionsMixins';
  import downloadSpreadSheetMixins from '@/mixins/downloadSpreadSheetMixins';
  import profilePermissionsMixin from '@/mixins/profilePermissionsMixin';

  export default {
    components: {
      DialogCreationLog: () => import('@/components/general/DialogCreationLog'),
      DialogDelete: () => import('@/components/general/DialogDelete'),
      DialogDetalhes: () => import('@/components/general/DialogDetalhes'),
      DialogSql: () => import('@/components/general/DialogDetalhes'),
      DialogMensagemErro: () => import('@/components/general/DialogDetalhes'),
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
      GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue')
    },
    mixins: [powerupsActionsMixins, downloadSpreadSheetMixins, profilePermissionsMixin],
    props: {
      titulo: {
        type: String,
        default: 'Relatórios'
      },
      items: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      powerupService: RelatoriosService,
      powerupEntityName: 'Relatório',
      search: '',
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Nome',
          value: 'nome'
        },
        {
          text: 'Executado',
          value: 'ultima_execucao'
        },
        {
          text: 'Nº de linhas',
          value: 'numero_registros'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-4'
        }
      ],
      dialogDetalhesHeader: [
        { text: 'Parâmetro', sortable: false },
        { text: 'Criterio', sortable: false },
        { text: 'Valor', sortable: false }
      ],
      dialogSql: false,
      dialogSqlData: '',
      dialogMensagemErro: false,
      dialogMensagemErroData: ''
    }),
    methods: {
      editarRelatorio(id, tipo) {
        tipo == 'CUSTOMIZADO' ? this.$router.push(`customizado/edit/${id}`) : this.$router.push(`edit/${id}`);
      },
      favoritar(item) {
        RelatoriosService.favoritar(item.id)
          .then(() => (item.favorito = !item.favorito))
          .catch(() =>
            this.$toast.error('Erro ao tentar favoritar/desfavoritar.', '', {
              position: 'topRight'
            })
          );
      },
      normalizeValueToDetalhesDialog(item) {
        return JSON.parse(item.estrutura_json).parametros_editaveis;
      },
      translateCriterio(criterio) {
        if (criterio == null) return '';
        switch (criterio.toUpperCase()) {
          case '=':
            return 'é igual a';
          case '<>':
            return 'é diferente de:';
          case '>=':
            return 'é maior ou igual a:';
          case '<=':
            return 'é menor ou igual a:';
          case '>':
            return 'é maior que:';
          case '<':
            return 'é menor que:';
          case 'IN':
            return 'pertence à lista:';
          case 'NOT IN':
            return 'não pertence à lista:';
          case 'ILIKE %X%':
            return 'contém';
          case 'NOT ILIKE %X%':
            return 'não contém';
          case 'ILIKE X%':
            return 'começa com';
          case 'ILIKE %X':
            return 'termina com';
          default:
            return '';
        }
      }
    }
  };
</script>

<style>
  .label-rdt-ta textarea {
    font-size: 12.5px !important;
    font-weight: 350 !important;
    color: rgba(0, 0, 0, 0.87) !important;
  }
  .truncate-title-rt {
    width: 600px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .fs-rt {
    font-size: 1.5625rem;
  }
  @media screen and (max-width: 1100px) {
    .truncate-title-rt {
      width: 550px;
    }
  }
  @media screen and (max-width: 800px) {
    .fs-rt {
      font-size: 1.2625rem;
    }
    .truncate-title-rt {
      width: 350px;
    }
  }
  @media screen and (max-width: 550px) {
    .fs-rt {
      font-size: 1.12rem;
    }
  }
</style>
